import { getProtocolMapping } from './protocolMapping';
import { apiProtocol } from './api';
import { portalProtocol } from './portal';
import { ooclProtocol } from './oocl';
import { siaProtocol } from './sia';

const protocols = {
  api: apiProtocol,
  oocl: ooclProtocol,
  portal: portalProtocol,
  sia: siaProtocol,
};

const getProtocol = async (request, dispatch) => {
  const {
    companyLocation: { market },
    line: { id: lineId },
  } = request;

  const protocolMapping = await getProtocolMapping();

  const protocolByLine = protocolMapping.find(
    ({ line: lId }) => lId === lineId
  );

  const protocol = protocolByLine?.markets[market]?.protocol || 'email';

  if (protocol === 'email') {
    // do nothing
    return;
  }

  try {
    return await protocols[protocol](request);
  } catch (error) {
    dispatch(
      'auth/new_notification',
      {
        type: 'notification',
        message: error.message,
        error: true,
      },
      { root: true }
    );
  }
};

export const processRequests = async (requests, dispatch) =>
  await Promise.all(
    requests.map(async (request) => await getProtocol(request, dispatch))
  );
